export const theme = {
  fonts: {
    body: 'Helvetica Now Display”, Helvetica Now, Helvetica Neue, Arial, sans-serif',
    heading: '"Avenir Next", sans-serif',
    monospace: 'Menlo, monospace'
  },
  colors: {
    text: '#000',
    background: '#fff',
    primary: '#141414'
  },
  breakpoints: ['768px', '992px']
}

// bold headings font-weight: 800;
